import React from 'react'

export default function CredentialsPage() {
  return (
    <div>CredentialsPage</div>
  )
}
